// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"9feb77c8","260":"4321751a","668":"995cc9c7","762":"87bbbfe0"}[chunkId] + ".js";
};